import { observable } from "mobx";

export default class CadastroStore {
    
    @observable tipoDoc;
    @observable nome;
    @observable documento;
    @observable data;
    @observable endereco;
    @observable cep;
    @observable email;
    @observable emailOpcional;
    @observable contato;
    @observable telefoneDdd;
    @observable telefoneNumero;
    @observable enviando;
    @observable salvando;


    constructor(service) {
        this.tipoDoc = "fisica"
        this.nome = ""
        this.documento = ""
        this.data = null
        this.endereco = ""
        this.cep = ""
        this.email = ""
        this.emailOpcional = "";
        this.contato="";
        this.telefoneDdd = ""
        this.telefoneNumero = ""

        this.enviando = false
        this.salvando = false

        this.service = service
    }

    setTipoDoc = (value) => {
        if (value != undefined && value != null)
            this.tipoDoc = value;
    }
    setNome = (value) => {
        this.nome = value
    }
    setDocumento = (value) => {
        this.documento = value
    }
    setData = (value) => {
        this.data = value
    }
    setEndereco = (value) => {
        this.endereco = value
    }
    setCep = (value) => {
        this.cep = value
    }
    setEmail = (value) => {
        this.email = value
    }
    setEmailOpcional = (value) => {
        this.emailOpcional = value;
    }
    setContato = (value) => {
        this.contato = value
    }
    setTelefoneDdd = (value) => {
        this.telefoneDdd = value
    }
    setTelefoneNumero = (value) => {
        this.telefoneNumero = value
    }

    montarPayload = () => {
        let payload = {}
        if(this.tipoDoc === "fisica") {
            payload = {
                "Pessoa": {
                  "Nome": this.nome,
                  "CPF": this.documento,
                  "DataNascimento": this.data,
                  "Endereco": this.endereco,
                  "Cep": this.cep,
                  "Ddd": this.telefoneDdd,
                  "Telefone": this.telefoneNumero,
                  "Ramal": "",
                  "Email": this.email
                },
                "Empresa": {
                  "RepresentanteBrasil": "S",
                  "Cnpj": "",
                  "Nome": "",
                  "Endereco": "",
                  "Pais": "",
                  "Estado": "",
                  "Cidade": "",
                  "Cep": "",
                  "Ddd": 0,
                  "Telefone": 0,
                  "Email": "",
                  "Contato": "",
                  "EmailOpcional": "",
                  "Parceiros": [
                  ],
                  "Perfis": [
                    0
                  ]
                }
              }
        } else if(this.tipoDoc === "juridica") {
            payload = {
                "Pessoa": {
                  "Nome": "",
                  "CPF": "",
                  "DataNascimento": "",
                  "Endereco": "",
                  "Cep": "",
                  "Ddd": 0,
                  "Telefone": 0,
                  "Ramal": "",
                  "Email": "",
                },
                "Empresa": {
                  "RepresentanteBrasil": "S",
                  "Cnpj": this.documento,
                  "Nome": this.nome,
                  "Endereco": this.endereco,
                  "Pais": "",
                  "Estado": "",
                  "Cidade": "",
                  "Cep": this.cep,
                  "Ddd": this.telefoneDdd,
                  "Telefone": this.telefoneNumero,
                  "Contato": this.contato,
                  "Email": this.email,
                  "EmailOpcional": this.emailOpcional,
                  "Parceiros": [
                  ],
                  "Perfis": [
                    0
                  ]
                }
              }
        }

        return payload
    }

    enviar = (fecharModal = () => {}, msgAviso = ()=> {}) => {
        this.enviando = true
        this.service.salvarPreCadastroUsuario(this.montarPayload()).then(response => {
            console.log(response);
        }).catch(err => console.error(err)
        ).finally(() => {
            this.enviando = false
            fecharModal();
            msgAviso();
        });
    }
}


// WEBPACK FOOTER //
// ./src/modules/controleacesso/stores/CadastroStore.js